import { render } from "./createOrganization.vue?vue&type=template&id=65bd03e5&scoped=true"
import script from "./createOrganization.vue?vue&type=script&lang=js"
export * from "./createOrganization.vue?vue&type=script&lang=js"

import "./createOrganization.vue?vue&type=style&index=0&id=65bd03e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bd03e5"]])

export default __exports__